<template>
<div>
 <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row class="bradcrumb">
        <router-link :to="{name: 'role-links' }" class="root">
            Dashboard
        </router-link> /
        <router-link :to="{name: 'admin-master' }" class="root">
            Admin Master
        </router-link>
        <span class="child">/ Program Type</span>
    </v-row><br />
    <!-- <center  class="heading"><h3>Admin Program Type</h3></center> -->
    <!-- <span v-if="org!=null">
      <center>
            <h3>
 
            </h3>
        </center> -->
      <!-- <center><h3> {{org.name}}  </h3></center> -->
    <!-- </span> -->
    <v-card class="card">
      <v-card-title class="heading justify-center">
        <span>Program Type</span>

      </v-card-title>
            <v-card class="box">
                        <div class="flex">
                            <div></div>
                            <div>
                                <a href="https://easycheck.s3.ap-south-1.amazonaws.com/sample_excel_files/programTypeSample.csv">
                            <v-btn :loading="loading3" :disabled="loading3" color="success" class="ma-2 white--text downbtn" @click="loader = 'loading3'">
                                <v-icon left dark>mdi-cloud-download</v-icon>
                                Download import CSV format
                            </v-btn>
                        </a>
                            </div>
                        </div>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" lg="4" sm="12">
                                    <v-file-input dense accept=".csv" v-model="file" :hint="file != null? '':'Please Select File'" persistent-hint color="rgb(1, 127, 152)" label="Choose File" prepend-icon="mdi-paperclip" outlined :show-size="1000">
                        </v-file-input>
                                </v-col>
                                <v-col cols="4"> </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <center>
                                        <v-btn @click="submitFile" :loading="output_load" class="button">
                                Upload
                                <v-icon right>mdi-cloud-upload</v-icon>
                            </v-btn>
                                    </center>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

     <v-card-text>
  <v-data-table
    :headers="headers"
    :items="programtype_list"
    class="elevation-1 nowrap"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">

        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details>
          </v-text-field>
          <span style="width: 20px"></span>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn class="button" v-on="on">Add Program Type</v-btn>
          </template>
          <v-card>
            <v-form v-model="valid">
            <v-card-title class="heading">
              <span >{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-text-field dense
                      v-model="editedItem.programTypeName"
                      item-text="programtype_list_id"
                      item-value="id"
                      persistent-hint
                      :hint="editedIndex==-1?'For example :: BTech, MTech':'For example :: BTech, MTech'"
                      label="Program Type Name"
                      :error="errorMsg.programTypeName?true:false"
                      :error-messages="errorMsg.programTypeName?'Required':''"
                       :rules="[v => !!v || 'required']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field dense
                      v-model="editedItem.programTypeDisplayName"
                      item-text="programtype_list_id"
                      item-value="id"
                      persistent-hint
                      :hint="editedIndex==-1?'For example :: Bachelor of Technology, Master of Technology':'For example :: Bachelor of Technology, Master of Technology'"
                      label="Program Type Display Name"
                      :error="errorMsg.programTypeDisplayName?true:false"
                      :error-messages="errorMsg.programTypeDisplayName?'Required':''"
                       :rules="[v => !!v || 'required']"
                    ></v-text-field>
                  </v-col>
                   <v-col cols="12" sm="6" md="4">
                    <v-checkbox
                        dense
                        v-model="editedItem.isactive"
                        color="success"
                        label="Active"
                      ></v-checkbox>
                  </v-col>     
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="primary darken-1"  @click="save" :disabled="!valid">Save</v-btn> -->
              <v-btn class="button-cancel" text @click="close">Cancel</v-btn>
              <v-btn class="button" @click="save" :disabled="!valid">Save</v-btn>
            </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

         <template v-slot:item.isactive="{ item }">
            <span v-if="item.isactive">
              <v-icon  class="mr-2  v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon  class="mr-2  v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>

    <template v-slot:item.action="{ item }">
     <div>
        <v-avatar style="" size="33" class="edit-avatar">
                <v-icon class="edit-v-icon mr-2" size="18" @click="editItem(item)">edit</v-icon>
            </v-avatar>
      </div>
    </template>
  </v-data-table>
     </v-card-text>
    </v-card>
  <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</div>
</template>

<script>
import axios from 'axios'
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  export default {
    data: () => ({
      valid: false,
      dialog_send: false,
      output_load:false,
      loading3: false,
      file: null,
      org: null,
       overlay: false,
      errorMsg:{
        proogramTypeId:false
      },
       snackbar_msg: "",
      color: "",
      snackbar: false,
      search:'',
      dialog: false,
      headers: [
        {
          text: 'Program Type Name',align: 'left',sortable: false,value: 'programTypeName',
        },
        {
          text: 'Program Type Display Name',align: 'left',sortable: false,value: 'programTypeDisplayName',
        },
        {
          text: 'Active',align: 'left',sortable: true,value: 'isactive',
        },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      programtype_list: [],
      editedIndex: -1,
      editedItem: {
        id: '',
        programTypeName: '',
        programTypeDisplayName: '',
        isactive:true  
      },
      defaultItem: {
        id: '',
        programTypeName: '',
        programTypeDisplayName: '',
        isactive:true      
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Program Type' : 'Edit Program Type'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
        overlay (val) {
        val= () => {
          this.overlay = false
        };
      },
    },

    // created () {
    //   this.initialize()
    // },
    mounted(){
       this.onLoad()
     },
    methods: {
        submitFile() {
            if (this.file == null) {
                this.showSnackbar("#b71c1c", "Please select the file!");
                //alert("Please select the file!");
            } else {
                this.output_load = true;
                this.dialog_send = true;
                let formData = new FormData();
                formData.append("file", this.file);
                axios
                    .post("AdminMaster/importProgramType", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.course_list = res.data.course_list;
                            this.load = true;
                            this.output_load = false;
                            this.dialog_send = false;
                            this.file = null
                            if(res.data.statuslist.length-1>1){
                               this.showSnackbar("#b71c1c", "CSV file contains error some rows are added successfully... ");
                            }
                             else{
                            this.showSnackbar("#4CAF50", "Program Type Imported Successfully !!");
                            }
                            this.onLoad();

                        } else {
                            this.output_load = false;
                            this.dialog_send = false;
                            this.showSnackbar("#b71c1c", res.data.datamsg);
                        }
                    })
                    .catch(function () {
                        console.log("FAILURE!!");
                    })
                    .finally(() => {
                        this.output_load = false;
                    });
            }
        },
      editItem (item) {
        this.editedIndex = this.programtype_list.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      onLoad(){
      this.overlay=true;
      axios
      .post("/AdminMaster/adminProgramType")
      .then(res => {
        if (res.data.msg == "200") {
          //window.alert(res.data.msg)
          if(this.load = true){
            this.overlay = false;
            this.org = res.data.org;
            this.programtype_list = res.data.programtype_list
          }
        } else {
          window.console.log(res.data.msg)
        }
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        window.console.log(error);
      })
      .finally(()=>{ 
        var overlay=false;
      });       
    },
      showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
       },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) 
        {
          if(this.isValidated())
         {
          axios
          .post("/AdminMaster/editAdminProgramType", this.editedItem)
          .then(res => {
            if (res.data.status.code == "SUCCESS") {
              //window.alert(res.data.msg)
              Object.assign(this.programtype_list[this.editedIndex], this.editedItem);
              this.showSnackbar(
                  "#4caf50",
                  "Program type Updated Successfully..."
                ); // show snackbar on success
            }
              else if(res.data.status.code == "NA"){
                this.showSnackbar("#b71c1c", "Program type Already Present!!!"); // show snackbar on error
            }
          })
          .catch(error => {
            window.console.log(error);
          });
            this.close()
         }
        } 
        else 
        {
           axios
          .post("/AdminMaster/saveAdminProgramType", this.editedItem)
          .then(res => {
            if (res.data.status.code == "SUCCESS") {
            //window.alert(res.data.status.code)
            this.programtype_list.push(this.editedItem)
             this.showSnackbar("#4caf50", "Program type Added Successfully!!!"); // show snackbar on success
             this.onLoad()    
            }
            else if(res.data.status.code == "NA"){
                //window.alert(res.data.status.code)
               // alert(res.data.status.message)
                this.showSnackbar("#b71c1c", "Program type Already Present!!!"); // show snackbar on error
            }
          })
          .catch(error => {
            window.console.log(error);
          });
          this.close()
        }
      }, //save()
      isValidated(){
      if(this.editedItem.programTypeId)
       { 
           return true; 
       }
      else{
            if(!this.editedItem.programTypeId)
            {
              this.errorMsg.programTypeId=true
            }
           
        return false;
      }  
     }, // .....end of isValidated()
    },
  }
</script>
<style scoped>
.downbtn {
    float: right;
}
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size{
  font-size: 20px;
}
.edit-avatar{
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover{
  background-color: #b0bec5;
}
.edit-v-icon{
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover{
  color: white;
}
.heading{
  background-color: #3f51b5;
  padding: 0.3rem;
  color: white;
}
.box {
        background-color: #add8e630;
        margin: 8px !important;
        padding: 8px;
    }
    .flex {
        display: flex;
        justify-content: space-between;
    }
    @media only screen and (max-width: 600px) {
        .flex {
            display: block;
        }
    }
</style>